import React from 'react';
import { connect } from 'react-redux';
import { updateField } from '../actions/FormActions';
import { getFieldProps } from '../selectors/hybrid';

const TextField = ({label, name, value, inline, hide, tooltip, note, changeHandler}) => {
  let classes = inline ? 'group inline textfield' : 'group textfield';
  classes = tooltip ? classes + ' has-tooltip' : classes;
  classes = hide ? classes + ' visuallyhidden' : classes;
  
  return (
    <div className={classes}>

      <input type="text" name={name} value={value} onChange={changeHandler} placeholder={label} required />
      <label htmlFor={name}>{label}</label>
      
      {tooltip ?
        <a tabIndex="0" role="button" className="btn tooltip"  data-bs-toggle="popover" data-bs-trigger="focus" data-bs-placement="right" data-bs-html="true" data-bs-title="Tool Tip:" data-bs-content={tooltip}>?</a> : null
      }
      
      {note ?
        <small>{note}</small> : null
      }
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return getFieldProps(state.ConfiguratorStore, ownProps.field.name);
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeHandler: (event) => {
      const target = event.target;
      const name = target.name
      const value = target.value;
      dispatch(updateField(name, value));
    }
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TextField);